module.exports = __webpack_public_path__ + "img/shadow_extra_rect_mask.fdba30dc.png";